
import { BookingStatus } from '../model/professional/booking-model';

/**
 * Couleurs pour les différents statuts d'événements
 */
export const EVENT_COLORS = {
  confirmed: '#4f46e5', // indigo
  cancelled: '#ef4444', // rouge
  completed: '#6b7280', // gris
};

/**
 * Fonction utilitaire pour obtenir la couleur en fonction du statut
 */
export const getStatusColor = (status: BookingStatus): string => {
  return EVENT_COLORS[status]
};

/**
 * Interface pour les événements à afficher dans le calendrier
 */
export interface CalendarDisplayEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  status: BookingStatus;
  color: string;
  bookingId?: string;
  isManualBooking?: boolean;
}
